import React from 'react';
import { Section } from './ui/Section';
import { Brain, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section background="white" data-id="element-178">
      <div className="max-w-6xl mx-auto" data-id="element-179">
        {/* Opening Lead */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-6" data-id="element-181">
            Hay un tipo de cansancio que no se arregla con "motivación"
          </h2>
          <p className="text-lg text-[#4B5563] mb-4 leading-relaxed" data-id="element-182">
            Es ese cansancio donde abrir el refri se siente como una pregunta
            imposible:
            <strong className="block text-xl mt-2 text-[#1F2937] font-semibold" data-id="element-183">
              ¿Qué como?
            </strong>
          </p>
          <p className="text-lg text-[#4B5563] leading-relaxed" data-id="element-184">
            Tu cabeza —que ya tomó 200 decisiones hoy— solo quiere{' '}
            <strong data-id="element-185">que esto sea fácil</strong>. Entonces pides algo, picoteas,
            improvisas, gastas... y después llega <em data-id="element-186">la culpa</em>.
          </p>
        </div>

        {/* The Real Problem */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-187">
          <div data-id="element-188">
            <h3 className="text-2xl md:text-3xl font-bold text-[#1F2937] mb-4" data-id="element-189">
              El problema real:{' '}
              <span className="text-[#1e3a8a]" data-id="element-190">La fatiga de decisiones</span>
            </h3>
            <p className="text-[#4B5563] mb-6" data-id="element-191">
              Si tu día ya viene lleno, la comida se convierte en "otra decisión
              más". Tu cerebro hace lo que está diseñado para hacer cuando está
              saturado:
            </p>
            <ul className="space-y-3 mb-6" data-id="element-192">
              {['Busca lo rápido', 'Evita lo difícil', 'Elige lo que requiere cero energía mental'].map((item, i) => <li key={i} className="flex items-center text-[#1F2937] font-medium" data-id="element-193">
                  <Brain className="w-5 h-5 text-[#1e3a8a] mr-3 flex-shrink-0" data-id="element-194" />
                  {item}
                </li>)}
            </ul>
            <p className="text-[#1F2937] font-semibold border-l-4 border-[#1e3a8a] pl-4" data-id="element-195">
              No es falta de carácter. Es un sistema que te exige rendimiento
              cuando estás en modo supervivencia.
            </p>
          </div>

          <div className="bg-[#EFF6FF] p-6 md:p-8 rounded-xl border border-[#DBEAFE]" data-id="element-196">
            <h4 className="text-xl font-bold text-[#1F2937] mb-6" data-id="element-197">
              Por qué el meal prep tradicional falla
            </h4>
            <div className="space-y-5" data-id="element-198">
              {[{
              title: 'El domingo "perfecto"',
              desc: 'Te prometes cocinar 4 horas, pero la vida pasa.'
            }, {
              title: '10 tuppers iguales',
              desc: 'Al tercer día te aburres y te da rechazo.'
            }, {
              title: 'Plan "Todo o Nada"',
              desc: 'Un día fallas y sientes que todo se rompió.'
            }].map((item, i) => <div key={i} className="flex items-start" data-id="element-199">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-200" />
                  <div data-id="element-201">
                    <h5 className="font-bold text-[#1F2937] text-sm" data-id="element-202">
                      {item.title}
                    </h5>
                    <p className="text-sm text-[#6B7280]" data-id="element-203">{item.desc}</p>
                  </div>
                </div>)}
            </div>
            <p className="text-[#4B5563] italic text-center mt-6 pt-6 border-t border-[#DBEAFE]" data-id="element-204">
              Era un plan para tu "yo ideal". No para tu "yo real".
            </p>
          </div>
        </div>
      </div>
    </Section>;
}